<div class="filter">
    <ng-content></ng-content>
    <div class="btns_container row fw_400 fz_s">
        <button class="btn btn_cancel" (click)="onCancel()">Очистить</button>
        <button class="btn dark_btn row" (click)="onApply()">Применить</button>
    </div>
</div>